import React from 'react';
import styled from 'styled-components';

const ChipWrap = styled.button`
  min-height: 40px;
  height: auto;
  border: 1px solid ${({ theme }) => theme.colorUI30};
  background: ${(props) => (props.isActive ? props.theme.colorUI20 : 'white')};
  border-radius: 50px;
  padding: 0 ${({ theme }) => theme.spacing02};
  font-size: ${({ theme }) => theme.fontSize03};
  color: ${({ theme }) => theme.colorText70};
  display: flex;
  align-items: center;
  :hover {
    cursor: pointer;
    background: ${({ theme }) => theme.colorUI20};
  }
`;

export default function Chip({ onClick, children, isActive, className }) {
  return (
    <ChipWrap className={`chip ${className ? className : ''}`} isActive={isActive} onClick={onClick}>
      {children}
    </ChipWrap>
  );
}
